import React from 'react';
import { CircleButton, Icon } from '@fnacdarty/back-office-ui';
import styled, { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { isLoggedIn } from '../../features/authentication/utils/auth';
import darty from '../../assets/images/logos/logo_cuisine_concepteur.png';

const StyledDiv = styled.div`
	transition: border-color 0.3s, box-shadow 0.3s ease;
	&:not(:last-child) {
		margin-bottom: 12px;
	}
	&:hover {
		border-color: red;
	}
	&:focus {
		border-color: ${({ theme }) => theme.colors.primary};
		box-shadow: 0 0 0 4px rgb(108 41 245 / 0.05);
	}
	&::placeholder {
		color: ${({ theme }) => theme.colors.muted};
	}
	&:disabled {
		background-color: #e3e3e3;
	}
	&:disabled::placeholder {
		color: ${({ theme }) => theme.colors.muted};
	}
`;

const StyledNav = styled.nav`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 80px;
	padding: 22px;
	background-color: ${({ theme }) => theme.colors.background};
	border-bottom: 1px solid #e9e9e9;
`;

const BrandHeadBar = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const handleButtonSettings = () => {
		navigate('/settings');
	};
	const isVersionPC = () =>
		window.innerWidth >= `${process.env.REACT_APP_PC_VERSION}`;

	return (
		<div style={{ position: 'relative', zIndex: '100' }}>
			<StyledNav>
				<a href="/">
					<img src={darty} alt="logo" width={60} />
				</a>
				{isLoggedIn() && isVersionPC() && (
					<StyledDiv>
						<CircleButton
							size={30}
							color={theme.colors.container}
							style={{
								position: 'absolute',
								right: '20px',
								top: '1px',
								boxShadow: `${theme.colors.secondary} 0px 4px 15px 0px`,
							}}
							onClick={handleButtonSettings}
						>
							<Icon
								name="cog"
								width={30}
								style={{ position: 'absolute', float: 'right' }}
								color={theme.colors.secondary}
							/>
						</CircleButton>
					</StyledDiv>
				)}
			</StyledNav>
		</div>
	);
};

BrandHeadBar.defaultProps = {
	theme: {
		colors: {
			background: '#ffffff',
		},
	},
};

export default BrandHeadBar;
